import { Observable } from 'rxjs/Observable'
import { orgId } from 'app/modules/org/selectors'
import { api } from './api'
import * as actions from './actions'

function fetchAttributes(action$, { getState }) {
  return action$.ofType(actions.fetchAttributes.toString())
    .exhaustMap(() => {
      return api.fetch(orgId(getState()))
        .map(actions.receiveAttributes)
        .takeUntil(action$.ofType(actions.fetchAttributesCancelled.toString()))
        .startWith(actions.fetchAttributesPending())
        .catch(error => Observable.of(actions.fetchAttributesFailed({ error })))
    })
}

export const epic = fetchAttributes



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/attribute/epic.js